import { render, staticRenderFns } from "./LkNotificationsBell.vue?vue&type=template&id=121a057c&scoped=true"
import script from "./LkNotificationsBell.vue?vue&type=script&lang=js"
export * from "./LkNotificationsBell.vue?vue&type=script&lang=js"
import style0 from "./LkNotificationsBell.vue?vue&type=style&index=0&id=121a057c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a057c",
  null
  
)

export default component.exports